/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Weight_TitleInputs */

const tr_katalog_desi_page_weight_title = /** @type {(inputs: Katalog_Desi_Page_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 desi kaç kilogram?`)
};

const en_katalog_desi_page_weight_title = /** @type {(inputs: Katalog_Desi_Page_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many kilograms is 1 desi?`)
};

const de_katalog_desi_page_weight_title = /** @type {(inputs: Katalog_Desi_Page_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Kilogramm ist 1 Desi?`)
};

const ru_katalog_desi_page_weight_title = /** @type {(inputs: Katalog_Desi_Page_Weight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скольким килограммам равен 1 деси?`)
};

/**
* | output |
* | --- |
* | "How many kilograms is 1 desi?" |
*
* @param {Katalog_Desi_Page_Weight_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_weight_title = /** @type {((inputs?: Katalog_Desi_Page_Weight_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Weight_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_weight_title(inputs)
	if (locale === "de") return de_katalog_desi_page_weight_title(inputs)
	if (locale === "ru") return ru_katalog_desi_page_weight_title(inputs)
	return tr_katalog_desi_page_weight_title(inputs)
});